<div class="container-fluid pb-3 pt-2">
    <h4 class="mb-2">Segnalibri utilizzabili</h4>
    <h6 class="mb-2">Vengono mostrati in rosso gli errori quando si prova ad accedere ad un campo di qualcosa che non è
        stato compilato.<br> Ad esempio il segnalibro "impressioni_perito_condizioni_rischio" di un incarico in cui non
        è stata fatta la
        perizia universale risulta in un errore.
        <br>
        La colonna "Risultato" rappresenta il testo con cui verrà sostituito un segnalibro al momento della generazione
        di un documento da template.
    </h6>
    <mat-divider></mat-divider>

    <form [formGroup]="form">
        <mat-form-field>
            <mat-label>
                Incarico con cui provare i segnalibri
            </mat-label>
            <incarico-picker formControlName="incarico"></incarico-picker>
        </mat-form-field>
    </form>

    <mat-divider></mat-divider>
    <table class="table table-striped">
        <thead>
            <tr>
                <td>
                    Segnalibro
                </td>
                <td>
                    Risultato
                </td>
                <td>
                    Errore
                </td>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let segnalibro of segnalibri$ | async">
                <td>
                    {{"${"}}{{segnalibro.key}}{{"}"}}
                </td>
                <td
                    [ngClass]="{ 'valore-segnalibro':true, 'table-warning' : segnalibro?.value === null || segnalibro?.value === undefined || segnalibro?.value?.length === 0  }">
                    {{segnalibro.value}}
                </td>
                <td [ngClass]="{ 'table-danger' : segnalibro?.error?.length  }">
                    {{segnalibro.error}}
                </td>
            </tr>
        </tbody>
    </table>

</div>